export default defineAppConfig({
    title: "Globy",
});
